import React from 'react';
import { Row } from 'react-bootstrap';
import { FormCol, FormFilterCard, FieldInput, FieldSelectIsActive } from 'motion-components';
import { useTranslation } from 'react-i18next';
//import { FieldSelectUserType, UserTypeValues } from 'shared-pages';
import { FieldSelectUserType, UserTypeValues } from 'shared-pages';
import { FieldSelectContributorGroups } from 'shared-pages/pages/cnt/components';
import { useFormikContext } from 'formik';
import { isRebattery } from 'shared-pages/common/constants';

/* ----------------------- Διαχείριση Φίλτρων ------------------------------ */
export function buildWhereFromFilterValues(values): string {
  // Φτιάξε το where για το graphql
  let where = {};
  if (values) {
    if (values.searchText) {
      const searchText = '%' + values.searchText + '%';
      const likeObj = { $like: searchText };
      where = {
        ...where,
        $or: [{ userName: likeObj }, { lastName: likeObj }, { firstName: likeObj }],
      };
    }
    if (values.isActive !== undefined && values.isActive !== null && values.isActive !== '') {
      where = { ...where, isActive: values.isActive };
    }
    if (values.usertypeId) {
      where = { ...where, usertypeId: values.usertypeId };
    }

    if (values.contributorGroupId) {
      where = { ...where, contributorGroupId: values.contributorGroupId };
    }
  }
  return JSON.stringify(where);
}

/* ----------------------- Filter Form ------------------------------ */
export const Filters = ({ onChange, initialValues }) => {
  //
  const { t } = useTranslation();
  function handleFiltersSubmit(values, { setSubmitting }) {
    setTimeout(() => {
      setSubmitting(false);
      onChange(values);
    }, 400);
  }
  //console.log("filters-init ", initialValues);

  const filters = {
    searchText: initialValues?.searchText ?? '',
    isActive: initialValues?.isActive ?? null,
    usertypeId: initialValues?.usertypeId ?? null,
    contributorGroupId: initialValues?.contributorGroupId ?? null,
  };

  const FilterFields = () => {
    const { values }: any = useFormikContext();
    return (
      <Row>
        <FieldInput
          as={FormCol}
          name="searchText"
          label={t('Αναζήτηση ( Χρήστης, Όνομα, Επώνυμο )')}
          type="search"
        />
        <FieldSelectUserType as={FormCol} />

        {values.usertypeId === UserTypeValues.Contributor && (
          <FieldSelectContributorGroups
            disabled={values.usertypeId !== UserTypeValues.Contributor}
            as={FormCol}
          />
        )}

        <FieldSelectIsActive label={t('Ενεργές Εγγραφές')} />
      </Row>
    );
  };

  return (
    <FormFilterCard
      title={t('Κριτήρια Αναζήτησης')}
      onSubmit={handleFiltersSubmit}
      initialValues={filters}
    >
      <FilterFields />
    </FormFilterCard>
  );
};
